import Vue from 'vue'
import Router from "vue-router"
import store from '@/store'

Vue.use(Router)

export const constantRoutes = [{
    path: '/',
    component: () => import('@/views/index.vue'),
    name: 'index',
    meta: { title_zh: '首页', title_en: 'Index' },
    hidden: true
}, {
    path: '/products',
    component: () => import('@/views/products/index.vue'),
    name: 'products',
    meta: { title_zh: '产品', title_en: 'Products' }
}, {
    path: '/shopping',
    component: () => import('@/views/shopping/index.vue'),
    name: 'shopping',
    meta: { title_zh: '商城与设计中心', title_en: 'Mall And Design' }
}, {
    path: '/news',
    component: () => import('@/views/news/index.vue'),
    name: 'news',
    meta: { title_zh: '新闻动态', title_en: 'News' }
},
{
    path: '/news-detail/:id',
    component: () => import('@/views/news-detail/index.vue'),
    name: 'news-detail',
    meta: { title_zh: '新闻动态详情页', title_en: 'News Detail' },
    hidden: true
},
{
    path: '/job',
    component: () => import('@/views/job/index.vue'),
    name: 'job',
    meta: { title_zh: '诚聘英才', title_en: 'Job' }
}, {
    path: '/about',
    component: () => import('@/views/about/index.vue'),
    name: 'about',
    meta: { title_zh: '关于威力铭', title_en: 'About Wellingmer' }
},]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history', // 不依赖于浏览器的特性，在所有浏览器中都兼容
    scrollBehavior: () => ({ y: 0 }), // 路由切换时，自动将滚动条位置设置到顶部
    routes: constantRoutes
})

//全局前置路由守卫————初始化的时候被调用、每次路由切换之前被调用
router.beforeEach((to, from, next) => {
    console.log(store.state.language.currentLanguage)
    // 这里的 to.meta.title 就是路由定义时设置的 title
    document.title = (store.state.language.currentLanguage === 'zh') ? `威力铭 - ${to.meta.title_zh}` : `Wellingmer - ${to.meta.title_en}`;
    next();
});


export default router
